import React from "react";

import LoginBrandPanel from "./LoginBrandPanel";
import okastLogo from "../../resources/okast_logo_black.png";

import type { JSX, ReactNode } from "react";

interface LoginLayoutProps {
  children: ReactNode;
  "data-testid"?: string;
}

function LoginLayout({
  children,
  "data-testid": dataTestId,
}: LoginLayoutProps): JSX.Element {
  return (
    <div
      className="@container/login flex h-full w-full"
      data-testid={dataTestId}
    >
      <div className="bg-card flex w-full shrink-0 overflow-y-auto @min-[56rem]/login:w-100 @min-[80rem]/login:w-112">
        <div className="m-auto flex w-full max-w-88 flex-col items-center gap-8 px-8 py-12">
          <img alt="OKAST" className="w-52 dark:invert" src={okastLogo} />
          {children}
        </div>
      </div>
      <LoginBrandPanel className="@max-[56rem]/login:hidden" />
    </div>
  );
}

export default LoginLayout;
